import React, { useState, useRef, useEffect } from "react";
import { useForm } from "react-hook-form";
import useLogin from "@Hooks/useLogin";
import LoadingComponent from "@Components/LoadingComponent/LoadingComponent";
import LogoTitle from "@Components/LogoTitle/LogoTitle";
import FormPageTemplate from "@Pages/FormPageTemplate/FormPageTemplate";
import loginLeftPage from "@Assets/LoginLeftPage.jpg";
import themeCreator from "@Themes/themeCreator";
import { useNavigate } from "react-router";
import { emailVerification } from "@Routes/DefaultRoutes";
import { setUser } from "@Redux/userSlice";
import { home } from "@Routes/DefaultRoutes";
import axios from "@API/axios";
import { GET_CURRENT_USER } from "@API/APIRoutes";
import { useDispatch } from "react-redux";
import {
  Grid,
  Typography,
  TextField,
  Button,
  Box,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import LoginPageStyles from "./LoginStyles";

export default function Login() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [userData, setUserData] = useState();
  const [showPassword, setShowPassword] = useState(false);

  const inputEmail = useRef(null);
  const inputPassword = useRef(null);

  const { error, loading } = useLogin(userData ? userData : null);
  const onLoginSubmit = (data) => {
    setUserData(data);
  };

  const customTheme = themeCreator();


  useEffect(() => {
    if (error) {
      if (inputEmail.current) {
        inputEmail.current.focus();
        inputEmail.current.value = "";
      }
      if (inputPassword.current) {
        inputPassword.current.value = "";
      }
    }
  }, [error]);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };
  const rightGridContent = (
    <>
      <form onSubmit={handleSubmit(onLoginSubmit)} className="formWrapper">
        <Grid
          container
          spacing={2}
          className="inputContainer"
          justifyContent="flex-end"
        >
          <Grid item xs={12} justifyContent="flex-start">
            <LogoTitle isDisabled />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" className="loginTitle">
              Login
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" sx={{ mb: 1 }} align="left">
              Email
            </Typography>
            <TextField
              variant="outlined"
              fullWidth
              placeholder="Email"
              {...register("email", { required: "Email is required" })}
              inputRef={inputEmail}
              error={error}
              helperText={errors.email?.message}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" sx={{ mb: 1 }} align="left">
              Password
            </Typography>
            <TextField
              type={showPassword ? "text" : "password"}
              variant="outlined"
              fullWidth
              placeholder="Password"
              {...register("password", { required: "Password is required" })}
              helperText={errors.password?.message}
              inputRef={inputPassword}
              error={error}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleTogglePassword} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            {error && (
              <Typography variant="p1" color="red.main">
                Wrong Email or Password
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} display="flex" justifyContent="flex-end">
            <Typography
              variant="body2"
              sx={{
                color: "primary.main",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => navigate(emailVerification)}
            >
              Forgot Password?
            </Typography>
          </Grid>

          <Box className="submissionBox">
            <Button
              type="submit"
              variant="contained"
              className="submissionButton"
              size="large"
            >
              {!loading ? (
                "Login"
              ) : (
                <LoadingComponent size="2em" thickness={5} color="white" />
              )}
            </Button>
          </Box>
        </Grid>
      </form>
    </>
  );

  return (
      <LoginPageStyles>
        <FormPageTemplate
          rightGridForm={rightGridContent}
          leftGridTitle="Welcome Back!"
          leftGridSubtitle="Track, manage, and assess Regulatory changes seamlessly. Your roles is vital in ensuring compliance and minimizing risks. Let’s streamline the process for smarter, more efficient decision-making!"
          textDown
          textColor={customTheme.palette.white.main}
          leftGridBG={loginLeftPage}
        />
      </LoginPageStyles>
  );
}
